import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.consult.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface ListingOption {
    id: string;
    title: string;
    rightType: string;
    registrationNumber: string;
    price: number | string;
}

interface PurchaseMethod {
    order: string;
    label: string;
    title: string;
    description: string;
    link: string;
    cta: string;
    highlights: string[];
}

interface BuyerInquiry {
    buyerName: string;
    company: string;
    contact: string;
    email: string;
    listingId: string;
    message: string;
    budget: any;
    privacyAgreed: boolean;
    commissionAgreed: boolean;
}

@Component({
    selector: 'wiz-page-consult-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.consult.item/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageConsultItemComponent implements OnInit {
    public isHubView: boolean = true;
    private routeListingId: string = '';
    public purchaseMethods: PurchaseMethod[] = [
        {
            order: '01',
            label: '관리자상담',
            title: '판매리스트에서 특정 권리 선택',
            description: '전체 판매리스트에서 관심 권리를 정한 뒤 특정 지정가와 요청사항을 남기면 관리자가 중개 상담을 진행합니다.',
            link: '/market/cases',
            cta: '전체 판매리스트 보기',
            highlights: ['특정 권리 기반', '특정 지정가 입력', '관리자 중개 상담']
        },
        {
            order: '02',
            label: '자유상담',
            title: '자유 주제 또는 구매 요건 접수',
            description: '구매 목적이 명확하지 않거나 별도 요건으로 권리를 찾고 싶을 때 상담 양식을 선택해 접수합니다.',
            link: '/qna',
            cta: '자유상담으로 이동',
            highlights: ['자유 상담', '특정 권리 구매', '요건 기반 구매']
        },
        {
            order: '03',
            label: 'AI검색',
            title: 'KIPRIS 기반 후보 추천',
            description: '특허/실용, 상표, 디자인별 조건을 입력해 후보 등록권리를 추천받고 선택한 권리로 상담을 요청합니다.',
            link: '/search/ai',
            cta: 'AI검색 시작',
            highlights: ['권리별 조건 입력', '최대 20개 후보', '선택 후 상담요청']
        }
    ];
    public listings: ListingOption[] = [];
    public loadingListing: boolean = false;
    public listingError: string = '';

    public inquiry: BuyerInquiry = this.createInquiry();
    public submitted: boolean = false;
    public submitting: boolean = false;
    public receiptNo: string = '';

    constructor(@Inject( Service) public service: Service) {
        const id = WizRoute.segment.id || '';
        this.routeListingId = id;
        this.isHubView = !id;
        this.inquiry = this.createInquiry(id);
    }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/market/cases')) return;
        if (!this.isHubView) await this.loadSelectedListing();
        await this.service.render();
    }

    public async loadSelectedListing() {
        this.loadingListing = true;
        this.listingError = '';
        this.listings = [];
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get_listing', { id: this.routeListingId });
            if (code !== 200) throw new Error(data?.message || '상담할 공개 매물을 불러오지 못했습니다.');
            if (data?.isExample) throw new Error('자료 예시는 실제 거래 상담 대상이 아닙니다.');
            this.listings = [{
                id: data.id,
                title: data.title,
                rightType: data.rightType,
                registrationNumber: data.registrationNumber,
                price: data.price
            }];
            this.inquiry.listingId = data.id;
        } catch (error) {
            this.listingError = error instanceof Error ? error.message : '상담할 매물을 불러오지 못했습니다.';
        } finally {
            this.loadingListing = false;
            await this.service.render();
        }
    }

    public get selectedListing() {
        return this.listings.find((item) => item.id === this.inquiry.listingId) || null;
    }

    public async submit() {
        const listing = this.selectedListing;
        if (!listing || !this.inquiry.buyerName.trim() || !this.inquiry.contact.trim() || !this.inquiry.email.trim() || !this.inquiry.message.trim() || !String(this.inquiry.budget || '').trim()) {
            await this.service.modal.error('상담 신청 필수 항목을 확인해주세요.');
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(this.inquiry.email.trim()) || this.inquiry.contact.replace(/\D/g, '').length < 9) {
            await this.service.modal.error('연락처와 이메일 형식을 확인해주세요.');
            return;
        }
        if (!this.inquiry.privacyAgreed || !this.inquiry.commissionAgreed) {
            await this.service.modal.error('개인정보 및 거래 수수료 동의가 필요합니다.');
            return;
        }

        this.submitting = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit_consultation', {
            payload: JSON.stringify({
                flow: 'buy_inquiry',
                data: {
                    requester: { name: this.inquiry.buyerName.trim(), company: this.inquiry.company.trim() },
                    contact: { phone: this.inquiry.contact.trim(), email: this.inquiry.email.trim() },
                    privacyAgreed: this.inquiry.privacyAgreed,
                    feeAgreed: this.inquiry.commissionAgreed,
                    details: {
                        rightId: listing.id,
                        rightTitle: listing.title,
                        registrationNumber: listing.registrationNumber,
                        rightType: listing.rightType,
                        price: this.formatPrice(listing.price),
                        budget: String(this.inquiry.budget),
                        request: this.inquiry.message.trim()
                    }
                }
            })
        });
        this.submitting = false;
        if (code !== 200) {
            await this.service.modal.error(this.consultationError(data));
            await this.service.render();
            return;
        }

        this.receiptNo = data.receiptNo;
        this.submitted = true;
        this.inquiry = this.createInquiry(this.routeListingId);
        await this.service.render();
    }

    public async resetForm() {
        this.inquiry = this.createInquiry(this.routeListingId);
        this.submitted = false;
        this.receiptNo = '';
        await this.service.render();
    }

    public formatPrice(price: number | string) {
        if (typeof price === 'string') return price;
        return price > 0 ? `${price.toLocaleString()}원` : '협의';
    }

    private createInquiry(listingId: string = ''): BuyerInquiry {
        return {
            buyerName: '',
            company: '',
            contact: '',
            email: '',
            listingId,
            message: '',
            budget: '',
            privacyAgreed: false,
            commissionAgreed: false
        };
    }

    public async toggleAgreement(key: 'privacyAgreed' | 'commissionAgreed') {
        this.inquiry[key] = !this.inquiry[key];
        await this.service.render();
    }

    private consultationError(data: any) {
        const message = data?.message || '상담 접수에 실패했습니다.';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'network') return `네트워크 오류: ${message}`;
        return `서버 오류: ${message}`;
    }
}

export default PageConsultItemComponent;